import { createForm as _createForm, IFormProps } from '@formily/core'

import { GenericalRecord, StrictOmit } from '@eastcoal/common/types/utilities'

import { FormMergeStrategy } from '../types/form'

export type FormOptions<T extends GenericalRecord> = StrictOmit<
  IFormProps<T>,
  'initialValues' | 'values'
> & {
  mergeStrategy?: FormMergeStrategy
  initialValues?: Partial<T> & GenericalRecord
  values?: Partial<T> & GenericalRecord
}

export const createForm = <T extends GenericalRecord>(
  options?: FormOptions<T>
) => {
  const form = _createForm(options)
  const { setInitialValues, setValues } = form

  form.setInitialValues = (values, strategy) => {
    setInitialValues.call(
      form,
      values,
      strategy ?? options?.mergeStrategy ?? 'shallowMerge'
    )
  }
  form.setValues = (values, strategy) => {
    setValues.call(
      form,
      values,
      strategy ?? options?.mergeStrategy ?? 'shallowMerge'
    )
  }

  return form
}
